import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@material-ui/icons/Add";
import TextField from "@material-ui/core/TextField";
import { InputAdornment } from "@mui/material";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@mui/icons-material/Search";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { withRouter } from "../../../withRouter";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import _ from "lodash";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import { EventList_Url, ImportEvents_Url } from "../../../provider/ServiceUrl";
import { ValidatorForm } from "react-material-ui-form-validator";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import EventTextImportTemplate from "../../../assets/importTemplate/EVENTtext_Import_Template.xlsx";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import LinearProgressWithLabel from "../popUp/LinearProgressWithLabel ";
import PtsAlert from "../ptsAlert/PtsAlert";
import Pagination from "../pagination/Pagination";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import DeleteButton from "../buttons/DeleteButton";

class EventList extends Component {
  header = store.getState().header.header;
  breadCrumb = [{ pageid: "", uiname: "Events" }];
  eventState = store.getState().applicationState.eventState;
  planType = store.getState().appUserData.appUserData.planType?.type;
  tollFreeNumberStatus = store.getState().appUserData.tollFreeNumberStatus;
  activeEventPaginationState = store.getState().paginations.activeEventsState;
  endedEventPaginationState = store.getState().paginations.endedEventsState;
  crmIntegration = store.getState().crmIntegration.crmIntegration;
  eventStateDetails = {};
  paginationStateDetails = {};
  constructor(props) {
    super(props);
    if (this.eventState) {
      this.eventStateDetails = Object.getOwnPropertyNames(this.eventState);
    }

    if (this.activeEventPaginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.activeEventPaginationState
      );
    }
    if (this.eventStateDetails.length > 0) {
      this.state = {
        action: props.action,
        pageNo: this.eventState.pageNo,
        pageSize: this.eventState.pageSize,
        selectedTab: this.eventState.selectedTab,
        eventList: [],
        futureEventList: [],
        activeEventList: [],
        endedEventList: [],
        cancelledEventList: [],
        skippedEvents: [],
        selectedFile: { name: "" },
        getCreatePermission: false,
        getDeletePermission: false,
        getUpdatePermission: false,
        isFutureEventListPaging: false,
        isActiveEventListPaging: false,
        isendedEventListPaging: false,
        isCancelledEventListPaging: false,
        eventId: this.eventState.eventId,
        isDragging: false,
        isProgress: false,
        isImportEventDisableOpen: false,
        openSkippedEvents: false,
        sortColumn: this.eventState.sortColumn,
        isAscSort: this.eventState.isAscSort,
        sortDirection: "asc",
        render: false,
        openDeleteEvent: false,
        eventStatus: "",
      };
    } else {
      this.state = {
        action: props.action,
        selectedTab: 0,
        pageNo: 0,
        pageSize:
          this.paginationStateDetails?.length > 0
            ? this.activeEventPaginationState?.pageSize
            : 20,
        eventList: [],
        futureEventList: [],
        activeEventList: [],
        endedEventList: [],
        cancelledEventList: [],
        skippedEvents: [],
        selectedFile: { name: "" },
        getCreatePermission: false,
        getDeletePermission: false,
        getUpdatePermission: false,
        isFutureEventListPaging: false,
        isActiveEventListPaging: false,
        isendedEventListPaging: false,
        isCancelledEventListPaging: false,
        eventId: "",
        isDragging: false,
        isProgress: false,
        isImportEventDisableOpen: false,
        openSkippedEvents: false,
        sortColumn: this.paginationStateDetails?.length > 0
          ? this.activeEventPaginationState?.sortColumn : null,
        isAscSort: this.paginationStateDetails?.length > 0
          ? this.activeEventPaginationState?.isAscSort : false,
        sortDirection: "asc",
        isDatanotfound: true,
        render: false,
        openDeleteEvent: false,
        isTollFreeNotVerifiedDialogOpen: false,
        eventStatus: "",
      };
    }
    this.getEventList(this.state.selectedTab, this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
    this.debouncedSearch = _.debounce(this.getEventList, 800);
  }

  // componentDidMount() {
  //   const postObject = {
  //     header: this.header,
  //   };
  //   FetchServerData.callPostService("/planms/getForEventText", postObject).then(
  //     (output) => {
  //       if (output.status === "SUCCESS") {
  //         let planList = output.data.planList;
  //         this.setState({
  //           render: true,
  //         });
  //       } else {
  //       }
  //     }
  //   );
  // }

  getEventList(selectedTab, pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      status: selectedTab === 0 ? "Active" : "Ended",
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService(EventList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let eventList = output.data.eventList;
          let page = output.data.page;
          let isEventImportEnabled = output.data.isEventImportEnabled;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getCreatePermission = getPermission[1];
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];

          let isFutureEventListPaging = false;
          let isActiveEventListPaging = false;
          let isendedEventListPaging = false;
          let isCancelledEventListPaging = false;
          let futureEventList = [];
          let activeEventList = [];
          let endedEventList = [];
          let cancelledEventList = [];

          for (let i = 0; i < eventList.length; i++) {
            eventList[i].startDate = Utils.ptsDateFormat(
              eventList[i].startDate
            );
            eventList[i].endDate = Utils.ptsDateFormat(eventList[i].endDate);
            eventList[i].createdon = Utils.ptsDateFormat(
              eventList[i].createdon
            );
            eventList[i].creditsAvailable = Utils.formatWithCommas(
              eventList[i].creditsAvailable
            );
            eventList[i].creditsConsumed = Utils.formatWithCommas(
              eventList[i].creditsConsumed
            );

            if (Utils.equalsIgnoreCase(eventList[i].status, "Future")) {
              futureEventList.push(eventList[i]);
            } else if (Utils.equalsIgnoreCase(eventList[i].status, "Active")) {
              activeEventList.push(eventList[i]);
            } else if (Utils.equalsIgnoreCase(eventList[i].status, "Ended")) {
              endedEventList.push(eventList[i]);
            } else if (
              Utils.equalsIgnoreCase(eventList[i].status, "Cancelled")
            ) {
              cancelledEventList.push(eventList[i]);
            }
          }

          for (let i = 0; i < futureEventList.length; i++) {
            futureEventList[i].rowNum = i + 1;
          }
          for (let i = 0; i < activeEventList.length; i++) {
            activeEventList[i].rowNum = i + 1;
          }
          for (let i = 0; i < endedEventList.length; i++) {
            endedEventList[i].rowNum = i + 1;
          }
          for (let i = 0; i < cancelledEventList.length; i++) {
            cancelledEventList[i].rowNum = i + 1;
          }

          if (futureEventList.length > this.state.pageSize) {
            isFutureEventListPaging = true;
          }
          if (futureEventList.length > this.state.pageSize) {
            isActiveEventListPaging = true;
          }
          if (endedEventList.length > this.state.pageSize) {
            isendedEventListPaging = true;
          }
          if (endedEventList.length > this.state.pageSize) {
            isCancelledEventListPaging = true;
          }

          this.setState({
            render: true,
            openDeleteEvent: false,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            isDatanotfound: page.total === 0 ? true : false,
            isEventImportEnabled: isEventImportEnabled,
            futureEventList: futureEventList,
            activeEventList: activeEventList,
            endedEventList: endedEventList,
            cancelledEventList: cancelledEventList,
            isFutureEventListPaging: isFutureEventListPaging,
            isActiveEventListPaging: isActiveEventListPaging,
            isendedEventListPaging: isendedEventListPaging,
            isCancelledEventListPaging: isCancelledEventListPaging,
            getCreatePermission: getCreatePermission,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      }
    );
  }

  setKey(tab) {
    const tabPaginationMap = {
      0: this.activeEventPaginationState,
      1: this.endedEventPaginationState,
    };
    const paginationState = tabPaginationMap[tab] || {};

    const pageSize = paginationState?.pageSize ?? 100;
    const sortColumn = paginationState?.sortColumn ?? null;
    const isAscSort = paginationState?.isAscSort ?? false;
    this.getEventList(tab, this.state.pageNo, pageSize, sortColumn, isAscSort);

    this.setState({
      render: true,
      isDatanotfound: false,
      selectedTab: tab,
      totalRecords: 0,
      pageNo: 0,
      pageSize: pageSize,
    });
  }

  async addEvent() {
    this.props.navigate("/event", {
      state: {
        action: "create",
      },
    });
  }

  toEventDetails(e, data) {
    let eventState = {
      eventId: data.id,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      selectedTab: this.state.selectedTab,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(ApplicationStateAction.setApplicationState({ eventState }));
    this.setState({
      action: "view",
      eventId: data.id,
      profileList: this.state.profileList,
    });
  }

  toProfileDetails(e, data) {
    if (
      this.referenceProfileDialogueRef &&
      this.referenceProfileDialogueRef.current
    ) {
      this.referenceProfileDialogueRef.current.getProfileDetails(
        data.profileId
      );
    }
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ pageNo: page, pageSize: pageSize });
  }

  viewEventDetails(e, data) {
    if (e.target.closest(".action-button")) return;
    let eventState = {
      eventId: data.id,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      eventName: data.name,
      eventStartDate: data.startDate,
      eventEndDate: data.endDate,
      selectedTab: this.state.selectedTab,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(ApplicationStateAction.setApplicationState({ eventState }));
    store.dispatch(SelectedDomainAction.setSelectedDomain(data?.id));
    store.dispatch(SelectedDomainAction.setEventState(data));
    store.dispatch(ActiveMenuAction.setActiveMenu({}));
    store.dispatch(ActiveMenuAction.setActiveChildMenu("/eventMessages"));
    this.props.navigate("/eventMessages", {
      state: {
        action: "view",
        eventId: data.id,
      },
    });
  }

  editEventDetails(data) {
    let eventState = {
      eventId: data.id,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      eventName: data.name,
      eventStartDate: data.startDate,
      eventEndDate: data.endDate,
      selectedTab: this.state.selectedTab,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(ApplicationStateAction.setApplicationState({ eventState }));
    store.dispatch(SelectedDomainAction.setSelectedDomain(data?.id));
    store.dispatch(SelectedDomainAction.setEventState(data));
    store.dispatch(ActiveMenuAction.setActiveChildMenu("/eventMessages"));
    this.props.navigate("/editEvent", {
      state: {
        action: "edit",
        eventId: data.id,
      },
    });
  }

  showActionButton(rowData) {
    return (
      <>
        {(this.state.getDeletePermission && rowData.status === "Ended") &&
          <div className="ms-1 action-button" style={{ cursor: "pointer" }}>
            <i
              className="fa-regular fa-trash-can"
              aria-hidden="true"
              style={{
                borderRadius: "25%",
                color: "#6A7B8E",
                fontSize: "18px",
                width: "30px",
                minHeight: "30px",
                padding: "3px",
                alignContent: "center",
                textAlign: "center",
                fontWeight: "600",
              }}
              onClick={this.handleDeleteEventOpen.bind(this, rowData)}
            ></i>
          </div>
        }
        {(this.state.getUpdatePermission && rowData.isDatechangeRequested) &&
          <div className="action-button bannertextEditor ps-3">
            <Tooltip
              title="Date Change Requested"
              classes={{ popper: "custom-tooltip" }}
              arrow
            >
              <EventRepeatIcon
                onClick={this.editEventDetails.bind(this, rowData)}
                style={{ color: "#6a7b8e" }}
              />
            </Tooltip>
          </div>
        }
      </>
    );
  }

  handleImportEventDropdownOpen = (e) => {
    this.setState({
      isImportOpen: true,
      anchorEl: e.currentTarget,
      progress: 0,
      isProgress: false,
      isTollFreeNotVerifiedDialogOpen: false,
    });
  };

  handleImportEventTollfreeNumberNotVerifiedOpen = (e) => {
    this.setState({
      isTollFreeNotVerifiedDialogOpen: true,
    });
  };
  handleTollFreeNotVerifiedDialogClose = (e) => {
    this.setState({
      isTollFreeNotVerifiedDialogOpen: false,
    });
  };
  handleImportEventDropdownClose = () => {
    this.setState({
      isImportOpen: false,
      selectedFile: { name: "" },
    });
  }


  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.onFileChange(file);
    }
  };
  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedFile: file, isDragging: false });
      this.onFileChange(file);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  cancelImportEventExcelFile() {
    this.setState({
      selectedFile: { name: "" }
    })
  }

  onFileChange = (file) => {
    if (file) {
      const fileName = file.name.toLowerCase();
      const isValid =
        fileName.endsWith(".xls") ||
        fileName.endsWith(".xlsx");
      if (!isValid) {
        PtsAlert.error("Please upload valid XLSX file.");
        this.setState({ selectedFile: { name: "" } });
        return;
      }
      this.setState({ selectedFile: file });
    }
  };

  excelImportEventToBackend = () => {
    this.setState({ isProgress: true, progress: 0 });

    if (!this.state.selectedFile?.name) {
      PtsAlert.error("Please select file to upload");
      this.setState({ isProgress: false });
      return;
    }

    const header = store.getState().header.header;
    const formData = new FormData();

    formData.append("file", this.state.selectedFile, this.state.selectedFile.name);
    formData.append("sessionid", header.sessionid);
    formData.append("tid", header.tid);
    formData.append("userid", header.userid);
    formData.append("appclient", header.appclient);
    formData.append("isAp", header.isAp);

    FetchServerData.callPostFileUpload(ImportEvents_Url, formData, {
      timeout: 0,
      onUploadProgress: (progressEvent) => {
        if (!progressEvent.total) return;

        // Upload progress → 0–60%
        const uploadPercent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        const mapped = Math.min(60, Math.round(uploadPercent * 0.6));
        this.setState({ progress: mapped });
      },
    })
      .then((output) => {
        this.stopPendingProgress();

        if (output.status === "SUCCESS") {
          const skippedEvents = output?.data?.errors || [];

          this.setState({ progress: 100 }, () => {
            setTimeout(() => {
              this.setState({
                isProgress: false,
                isImportOpen: false,
              });

              // if (skippedEvents.length > 0) {
              //   this.setState({
              //     openSkippedEvents: true,
              //     skippedEvents,
              //   });
              // }

              this.getEventList(
                this.state.selectedTab,
                this.state.pageNo,
                this.state.pageSize,
                this.state.sortColumn,
                this.state.isAscSort
              );
            }, 800);
          });
        } else {
          this.setState({ isProgress: false });
        }
      })
      .catch(() => {
        this.stopPendingProgress();
        this.setState({ isProgress: false });
        PtsAlert.error("Event import failed");
      });

    this.startPendingProgress();
  };

  startPendingProgress = () => {
    this.pendingTimer = setInterval(() => {
      this.setState((prev) => {
        if (prev.progress >= 90) return null;
        return { progress: prev.progress + 1 };
      });
    }, 700);
  };

  stopPendingProgress = () => {
    if (this.pendingTimer) {
      clearInterval(this.pendingTimer);
      this.pendingTimer = null;
    }
  };

  handleSkippedEventsClose = () => {
    this.setState({
      openSkippedEvents: false,
    });
  };

  handleImportEventDisableOpen() {
    this.setState({
      isImportEventDisableOpen: true,
    });
  }
  handleImportEventDisableClose() {
    this.setState({
      isImportEventDisableOpen: false,
    });
  }

  requestActivateImportContact() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/supportms/requestActivateImportContact",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          isImportEventDisableOpen: false,
        });
      } else {
      }
    });
  }

  renderSortIcon(column) {
    if (this.state.sortColumn !== column) return null;

    return this.state.sortDirection === "asc" ? (
      <i className="fa fa-long-arrow-up ps-1" aria-hidden="true"></i>
    ) : (
      <i className="fa-solid fa-arrow-down-long ps-1"></i>
    );
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const eventsState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };

    if (this.state.selectedTab === 0) {
      store.dispatch(
        PaginationRowAction.setActiveEventsPaginationState({ activeEventsState: eventsState })
      );
    } else if (this.state.selectedTab === 1) {
      store.dispatch(
        PaginationRowAction.setEndedEventsPaginationState({ endedEventsState: eventsState })
      );
    }

    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.getEventList(this.state.selectedTab, currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(
      this.state.selectedTab,
      this.state.pageNo,
      this.state.pageSize
    );
  }

  handleSort(column) {
    const { sortColumn, sortDirection, selectedTab, pageNo, pageSize } =
      this.state;

    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    const isAscSort = newDirection === "asc";
    const eventsState = {
      pageSize,
      sortColumn: column,
      isAscSort,
    };
    if (selectedTab === 0) {
      store.dispatch(
        PaginationRowAction.setActiveEventsPaginationState({ optinContactsState: eventsState })
      );
    } else {
      store.dispatch(
        PaginationRowAction.setEndedEventsPaginationState({ invalidContactsState: eventsState })
      );
    }

    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        this.getEventList(
          selectedTab,
          pageNo,
          pageSize,
          column,
          isAscSort
        );
      }
    );
  }
  handleDeleteEventOpen(data) {
    this.setState({
      openDeleteEvent: true,
      eventStatus: data.status,
      eventName: data.name,
      eventId: data.id,
    })
  }
  handleDeleteEventClose() {
    this.setState({
      openDeleteEvent: false,
    })
  }

  deleteEventToBackend() {
    const postObject = {
      header: this.header,
      event: {
        id: this.state.eventId,
      },
    };

    FetchServerData.callPostService("/eventms/delete", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getEventList(
            this.state.selectedTab,
            this.state.pageNo,
            this.state.pageSize,
            this.state.sortColumn,
            this.state.isAscSort
          );
        } else {
        }
      })
      .catch((error) => { });
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name="Events"
        />
        <div style={{ maxWidth: "100%", marginTop: "0.5em" }} id="eventList">
          <Tabs
            defaultIndex={this.state.selectedTab}
            onSelect={(k) => this.setKey(k)}
          >
            <TabList
              style={{ listStyle: "none" }}
              className="text-start d-flex flex-wrap justify-content-start ps-0 mb-0"
            >
              <Tab className="tabSetting hoverTab">
                <span className="tabCompleted">Current & Upcoming</span>
              </Tab>
              <Tab className="tabSetting hoverTab">
                <span className="tabCompleted">History</span>
              </Tab>
            </TabList>
            <TabPanel className="materialTable">
              <div className="row">
                <div className="col md-12">
                  <div className="card rounded-0">
                    <div
                      className="row justify-content-between"
                      style={{ padding: "0.6em 1.2rem" }}
                    >
                      <div className="d-flex col-12 col-lg-9 col-xl-9">
                        <div className="col-12 d-flex">
                          {this.state.getCreatePermission && (
                            <>
                              <Button
                                id="ptsGreenSolidButton"
                                type="button"
                                variant="contained"
                                sx={{ height: "30px" }}
                                startIcon={<AddIcon style={{ fontWeight: "600" }} />}
                                onClick={() => this.addEvent()}
                              >
                                {Utils.equalsIgnoreCase(this.planType, "Onetime")
                                  ? "Purchase Event"
                                  : "Add Event"}
                              </Button>
                              &nbsp;&nbsp;
                              {!Utils.equalsIgnoreCase(this.planType, "Onetime") &&
                                (
                                  this.state.isEventImportEnabled ?
                                    <Button
                                      id="ptsSolidButton"
                                      variant="contained"
                                      type="button"
                                      sx={{ height: "30px" }}
                                      startIcon={
                                        <UploadFileIcon />
                                      }
                                      onClick={(event) => {
                                        (this.tollFreeNumberStatus === "Verified" ||
                                          this.tollFreeNumberStatus === "Approved") ?
                                          this.handleImportEventDropdownOpen(event) : this.handleImportEventTollfreeNumberNotVerifiedOpen(event)
                                      }}
                                    >
                                      Import Events
                                    </Button> :
                                    <Button
                                      id="ptsSolidButton"
                                      variant="contained"
                                      type="button"
                                      sx={{ height: "30px" }}
                                      startIcon={
                                        <UploadFileIcon />
                                      }
                                      onClick={(event) => this.handleImportEventDisableOpen(event)}
                                    >
                                      Import Events
                                    </Button>
                                )}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-3 col-xl-3 text-end align-self-center">
                        <div className="col-sm-12 text-end align-self-center">
                          <span className="me-1">
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="text"
                              variant="standard"
                              style={{ width: "193px" }}
                              value={this.state.searchText}
                              onChange={this.onSearchChange.bind(this)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      onClick={this.getEventList.bind(
                                        this,
                                        this.state.selectedTab,
                                        this.state.pageNo,
                                        this.state.pageSize
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        this.setState({ searchText: "" }, () => {
                                          this.getEventList(
                                            this.state.selectedTab,
                                            this.state.pageNo,
                                            this.state.pageSize
                                          );
                                        });
                                      }}
                                      disabled={!this.state.searchText}
                                    >
                                      <ClearIcon
                                        style={{
                                          opacity: this.state.searchText
                                            ? 1
                                            : 0.4,
                                          fontSize: "1.25rem",
                                          color: "353538",
                                        }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive paginationTable">
                      <table className="table text-start table-hover">
                        <thead className="paginationTableThead">
                          <tr>
                            <th scope="col fw-bold" style={{ width: "25px" }}>#</th>
                            <th scope="col fw-bold" style={{ cursor: "pointer", width: "160px" }} onClick={() => this.handleSort("name")}
                            >
                              Event Name
                              {this.renderSortIcon("name")}
                            </th>
                            {this.crmIntegration === "Cvent" &&
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "120px" }} onClick={() => this.handleSort("code")}
                              >
                                Cvent Code
                                {this.renderSortIcon("code")}
                              </th>
                            }
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "120px" }}
                              onClick={() => this.handleSort("startDate")}
                            >
                              Start Date
                              {this.renderSortIcon("startDate")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "120px" }}
                              onClick={() => this.handleSort("endDate")}
                            >
                              End Date
                              {this.renderSortIcon("endDate")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "120px" }}
                              onClick={() => this.handleSort("createdon")}
                            >
                              Created On
                              {this.renderSortIcon("createdon")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "180px" }}
                              onClick={() => this.handleSort("location")}
                            >
                              Location
                              {this.renderSortIcon("location")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "120px" }}
                              onClick={() => this.handleSort("consumedCredits")}
                            >
                              Text Usage
                              {this.renderSortIcon("consumedCredits")}
                            </th>
                            <th style={{ width: "120px" }} scope="col fw-bold" onClick={() => this.handleSort("status")}>Status
                              {this.renderSortIcon("status")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ width: "120px" }}
                            > &nbsp;
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.activeEventList?.map((rowData, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  rowData.id === this.state.groupId
                                    ? "#FEF5E7"
                                    : "",
                              }}
                            >
                              <td style={{ width: "25px" }}>{(this.state.pageNo) * this.state.pageSize + (index + 1)}</td>
                              <td
                                style={{ width: "160px" }}
                              >
                                <span
                                  className="action-text anchortag" key={rowData.id}
                                  onClick={(e) => this.viewEventDetails(e, rowData)}
                                >
                                  {rowData?.name}
                                </span>
                              </td>
                              {this.crmIntegration === "Cvent" &&
                                <td
                                  style={{ width: "120px" }}
                                >
                                  {rowData.code}
                                </td>
                              }
                              <td
                                style={{ width: "120px" }}
                              >
                                {rowData.startDate}
                              </td>
                              <td
                                style={{ width: "120px" }}
                              >
                                {rowData.endDate}
                              </td>
                              <td
                                style={{ width: "120px" }}
                              >
                                {rowData.createdon}
                              </td>
                              <td
                                style={{ width: "180px" }}
                              >
                                {rowData.location}
                              </td>
                              <td
                                style={{ width: "120px" }}
                              >
                                {Utils.equalsIgnoreCase(this.planType, "Onetime") ? `${Utils.formatWithCommas(rowData?.consumedCredits)} /
                                ${Utils.formatWithCommas(rowData?.availableCredits)}` : Utils.formatWithCommas(rowData?.consumedCredits)}
                              </td>
                              <td
                                style={{ width: "120px" }}
                              >
                                {rowData.status}
                              </td>
                              <td
                                style={{ width: "120px" }}
                              >
                                <div className="d-flex" key={rowData.id}>
                                  {this.showActionButton(rowData)}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && this.state.isDatanotfound && (
                      <div
                        className="row text-center"
                        style={{ padding: "6px 20px" }}
                      >
                        <h5 className="dataNotAvailable">
                          No current or upcoming events found.
                        </h5>
                      </div>
                    )}
                    {this.state.totalRecords > 10 && (
                      <div className="row justify-content-between pagination p-1">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="pageSize col-12 text-start">
                            Page {this.state.pageNo + 1} of{" "}
                            {this.state.totalPages}
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            <Pagination
                              showPerPage={this.state.showPerPage}
                              onPaginationChange={this.onPaginationChange.bind(
                                this
                              )}
                              total={this.state.totalRecords}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div >
              <Dialog
                open={this.state.isImportOpen}
                onClose={this.handleImportEventDropdownClose}
                maxWidth="xl"
                className="importEventDialogue"
              >
                <DialogTitle id="scroll-dialog-title">
                  <span style={{ color: "#fff" }}>Import Events</span>
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={this.handleImportEventDropdownClose.bind(this)}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: 4,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
                </IconButton>
                <DialogContent>
                  <div className="row p-2">
                    <div className="col-sm-12">
                      <div className="row d-flex">
                        <div className="col-sm-12 text-end">
                          <label
                            style={{
                              float: "right",
                            }}
                          >
                            <a
                              href={EventTextImportTemplate}
                              style={{
                                color: "#1957b4",
                                cursor: "pointer",
                                fontSize: "13.5px",
                              }}
                              id="dwnlink"
                              download="GivBee_Event_List_Upload_Template.XLSX"
                            >
                              <u>Download XLSX template</u>
                            </a>
                          </label>
                        </div>
                      </div>
                      <ValidatorForm
                        className="text-start"
                        ref="form"
                        onSubmit={this.excelImportEventToBackend.bind(this)}
                      >
                        <div className="row mb-1 mt-2">


                          {this.state.selectedFile?.name === "" ?
                            <div
                              className="col-sm-8 d-flex csvFile"
                              style={{ display: "inline-block", cursor: "pointer" }}
                            >
                              <div className="file-upload-wrapper">
                                <label
                                  htmlFor="import-csvfile"
                                  className={`customImageVideo-file-upload ${this.state.isDragging ? "dragging" : ""
                                    }`}
                                  onDrop={this.handleDrop}
                                  onDragOver={this.handleDragOver}
                                  onDragLeave={this.handleDragLeave}
                                >
                                  <CloudUploadIcon className="upload-icon" />
                                  <span className="upload-text">
                                    Drop or{" "}
                                    <span className="browse-link">browse CSV files here</span>
                                  </span>

                                  <input
                                    required
                                    id="import-csvfile"
                                    type="file"
                                    accept=".csv, .xls, .xlsx"
                                    ref={this.fileUploadRef}
                                    onChange={this.handleFileChange}
                                  />
                                </label>

                                {/* <small className="upload-note">
                                  {this.state.selectedFile?.name === ""
                                    ? "Choose XLSX file"
                                    : this.state.selectedFile?.name}
                                </small> */}
                              </div>
                            </div>
                            :
                            <div
                              className="col-sm-12 d-flex csvFile"
                              style={{ display: "inline-block", cursor: "pointer" }}
                            >
                              <div className="align-content-center" style={{ height: "76.61px" }}>
                                <p
                                  className="mb-0 anchortag"
                                  id="fileLabel"
                                  style={{ display: "inline" }}
                                >
                                  {this.state.selectedFile?.name === ""
                                    ? ""
                                    : Utils.truncateString(this.state.selectedFile?.name, 60)}
                                </p>
                                <span className="fw-bold ms-2">
                                  <ClearIcon
                                    className="logoDelete"
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: "50%",
                                      border: "solid 2px",
                                      color: "#697a8d",
                                    }}
                                    onClick={this.cancelImportEventExcelFile.bind(
                                      this
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          }
                        </div>
                        <div className="row mt-3 align-items-center">
                          <div class="col-md-12 text-center">
                            {
                              this.state.selectedFile?.name !== "" ? (
                                <Button
                                  id="ptsButton"
                                  type="submit"
                                >
                                  Import
                                </Button>
                              ) : (
                                <Button disabled id="ptsButton" type="button">
                                  Import
                                </Button>
                              )}
                          </div>
                        </div>
                      </ValidatorForm>
                      <div className="row mt-2" style={{ height: "25px" }}>
                        {this.state.isProgress && (
                          <LinearProgressWithLabel value={this.state.progress} />
                        )}
                      </div>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
              <Dialog
                open={this.state.isTollFreeNotVerifiedDialogOpen}
                onClose={this.handleTollFreeNotVerifiedDialogClose}
                maxWidth="xl"
                className="importEventDialogue"
              >
                <DialogTitle id="scroll-dialog-title">
                  <span style={{ color: "#fff" }}>Import Events</span>
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={this.handleTollFreeNotVerifiedDialogClose.bind(this)}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: 4,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
                </IconButton>
                <DialogContent>
                  <div className="row p-2">
                    <p>
                      Your event(s) and text messages will be imported but the text messages cannot be scheduled for sending because your account's toll-free number is not yet verified. If you continue with this import, you will need to manually schedule each message later.
                    </p>
                    <p>We recommend that you wait to import this file until after your toll-free number is verified. </p>
                  </div>
                </DialogContent>
                <DialogActions
                  style={{
                    // marginTop: "1em",
                    padding: "1em",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  <Button
                    variant="contained"
                    type="button"
                    size="large"
                    style={{
                      background: "#37517e",
                      color: "#fff",
                      marginRight: "0.6rem",
                      padding: "2px 10px",
                      textTransform: "capitalize",
                    }}
                    onClick={this.handleImportEventDropdownOpen.bind(this)}
                  >
                    Continue Import
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    type="button"
                    style={{
                      background: "#717373",
                      color: "#fff",
                      marginRight: "1rem",
                      padding: "2px 10px",
                      textTransform: "capitalize",
                    }}
                    startIcon={<CloseIcon />}
                    onClick={this.handleTollFreeNotVerifiedDialogClose.bind(this)}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.openSkippedEvents}
                onClose={this.handleSkippedEventsClose}
                maxWidth="xl"
                className="importContactDialogue"
              >
                <DialogTitle id="scroll-dialog-title">
                  <span style={{ color: "#fff" }}>Import Events</span>
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={this.handleSkippedEventsClose.bind(this)}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: 4,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
                </IconButton>
                <DialogContent>
                  <div className="row p-2">
                    <p className="ps-2">Events will be imported but Messages will not be scheduled for following reasons. Please reschedule them once Tollfree number is approved.</p>
                    {this.state.skippedEvents &&
                      this.state.skippedEvents.length > 0 ? (
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th
                              style={{
                                width: "48px",
                                fontSize: "14px",
                              }}
                            >
                              #
                            </th>
                            <th
                              style={{
                                textTransform: "capitalize",
                                fontSize: "14px",
                              }}
                            >
                              Reason
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.skippedEvents.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td style={{ color: "red" }}>{item}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center text-muted">
                        No skipped events found.
                      </div>
                    )}
                  </div>
                </DialogContent>
              </Dialog>
              <Dialog
                open={this.state.isImportEventDisableOpen}
                onClose={this.handleImportEventDisableClose.bind(this)}
                style={{ padding: "1em" }}
              >
                <DialogContent>
                  <div className="row">
                    <span style={{ textAlign: "center" }}>
                      <p className="m-0" style={{ fontSize: "16px" }}>
                        Please contact customer support to activate this feature.
                      </p>
                    </span>
                  </div>
                </DialogContent>
                <DialogActions
                  style={{
                    // marginTop: "1em",
                    padding: "1em",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  <Button
                    variant="contained"
                    type="button"
                    size="large"
                    style={{
                      background: "#37517e",
                      color: "#fff",
                      marginRight: "1rem",
                      padding: "2px 10px",
                      textTransform: "capitalize",
                    }}
                    onClick={this.requestActivateImportContact.bind(this)}
                  >
                    Contact Customer Support
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    type="button"
                    style={{
                      background: "#717373",
                      color: "#fff",
                      marginRight: "1rem",
                      padding: "2px 10px",
                      textTransform: "capitalize",
                    }}
                    startIcon={<CloseIcon />}
                    onClick={this.handleImportEventDisableClose.bind(this)}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
            </TabPanel>
            <TabPanel className="materialTable">
              <div className="row">
                <div className="col md-12">
                  <div className="card rounded-0">
                    <div
                      className="row justify-content-between"
                      style={{ padding: "0.6em 1.2rem" }}
                    >
                      <div className="d-flex col-12 col-lg-9 col-xl-9">

                      </div>
                      <div className="d-flex col-12 col-lg-3 col-xl-3 text-end align-self-center">
                        <div className="col-sm-12 text-end align-self-center">
                          <span className="me-1">
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="text"
                              variant="standard"
                              style={{ width: "193px" }}
                              value={this.state.searchText}
                              onChange={this.onSearchChange.bind(this)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      onClick={this.getEventList.bind(
                                        this,
                                        this.state.selectedTab,
                                        this.state.pageNo,
                                        this.state.pageSize
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        this.setState({ searchText: "" }, () => {
                                          this.getEventList(
                                            this.state.selectedTab,
                                            this.state.pageNo,
                                            this.state.pageSize
                                          );
                                        });
                                      }}
                                      disabled={!this.state.searchText}
                                    >
                                      <ClearIcon
                                        style={{
                                          opacity: this.state.searchText
                                            ? 1
                                            : 0.4,
                                          fontSize: "1.25rem",
                                          color: "353538",
                                        }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive paginationTable">
                      <table className="table text-start table-hover">
                        <thead className="paginationTableThead">
                          <tr>
                            <th scope="col fw-bold" style={{ width: "25px" }}>#</th>
                            <th scope="col fw-bold" style={{ cursor: "pointer", width: "160px" }} onClick={() => this.handleSort("name")}
                            >
                              Event Name
                              {this.renderSortIcon("name")}
                            </th>
                            {this.crmIntegration === "Cvent" &&
                              <th scope="col fw-bold" style={{ cursor: "pointer", width: "120px" }} onClick={() => this.handleSort("code")}
                              >
                                Cvent Code
                                {this.renderSortIcon("code")}
                              </th>
                            }
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "120px" }}
                              onClick={() => this.handleSort("startDate")}
                            >
                              Start Date
                              {this.renderSortIcon("startDate")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "120px" }}
                              onClick={() => this.handleSort("endDate")}
                            >
                              End Date
                              {this.renderSortIcon("endDate")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "120px" }}
                              onClick={() => this.handleSort("createdon")}
                            >
                              Created On
                              {this.renderSortIcon("createdon")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "180px" }}
                              onClick={() => this.handleSort("location")}
                            >
                              Location
                              {this.renderSortIcon("location")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ cursor: "pointer", width: "120px" }}
                              onClick={() => this.handleSort("consumedCredits")}
                            >
                              Text Usage
                              {this.renderSortIcon("consumedCredits")}
                            </th>
                            <th style={{ width: "120px" }} scope="col fw-bold" onClick={() => this.handleSort("status")}>Status
                              {this.renderSortIcon("status")}
                            </th>
                            <th
                              scope="col fw-bold"
                              style={{ width: "120px" }}
                            > &nbsp;
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.endedEventList?.map((rowData, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  rowData.id === this.state.groupId
                                    ? "#FEF5E7"
                                    : "",
                              }}
                            >
                              <td style={{ width: "25px" }} >{(this.state.pageNo) * this.state.pageSize + (index + 1)}</td>
                              <td
                                style={{ width: "160px" }}
                                onClick={(e) => this.viewEventDetails(e, rowData)}
                              >
                                <span
                                  className="action-text anchortag" key={rowData.id}
                                >
                                  {rowData?.name}
                                </span>
                              </td>
                              {this.crmIntegration === "Cvent" &&
                                <td
                                  style={{ width: "120px" }} onClick={(e) => this.viewEventDetails(e, rowData)}
                                >
                                  {rowData.code}
                                </td>
                              }
                              <td
                                style={{ width: "120px" }}
                                onClick={(e) => this.viewEventDetails(e, rowData)}
                              >
                                {rowData.startDate}
                              </td>
                              <td
                                style={{ width: "120px" }}
                                onClick={(e) => this.viewEventDetails(e, rowData)}
                              >
                                {rowData.endDate}
                              </td>
                              <td
                                style={{ width: "120px" }}
                                onClick={(e) => this.viewEventDetails(e, rowData)}
                              >
                                {rowData.createdon}
                              </td>
                              <td
                                style={{ width: "180px" }}
                                onClick={(e) => this.viewEventDetails(e, rowData)}
                              >
                                {rowData.location}
                              </td>
                              <td
                                style={{ width: "120px" }}
                                onClick={(e) => this.viewEventDetails(e, rowData)}
                              >
                                {Utils.equalsIgnoreCase(this.planType, "Onetime") ? `${Utils.formatWithCommas(rowData?.consumedCredits)} /
                                ${Utils.formatWithCommas(rowData?.availableCredits)}` : Utils.formatWithCommas(rowData?.consumedCredits)}
                              </td>
                              <td
                                style={{ width: "120px" }}
                                onClick={(e) => this.viewEventDetails(e, rowData)}
                              >
                                {rowData.status}
                              </td>
                              <td
                                style={{ width: "120px" }}
                              >
                                <div className="d-flex" key={rowData.id}>
                                  {this.showActionButton(rowData)}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && this.state.isDatanotfound && (
                      <div
                        className="row text-center"
                        style={{ padding: "6px 20px" }}
                      >
                        <h5 className="dataNotAvailable">
                          No current or upcoming events found.
                        </h5>
                      </div>
                    )}
                    {this.state.totalRecords > 10 && (
                      <div className="row justify-content-between pagination p-1">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="pageSize col-12 text-start">
                            Page {this.state.pageNo + 1} of{" "}
                            {this.state.totalPages}
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            <Pagination
                              showPerPage={this.state.showPerPage}
                              onPaginationChange={this.onPaginationChange.bind(
                                this
                              )}
                              total={this.state.totalRecords}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div >
            </TabPanel>
            <Dialog
              open={this.state.openDeleteEvent}
              onClose={this.handleDeleteEventClose.bind(this)}
              // onHide={this.close}
              style={{ padding: "1em" }}
              className="deleteEventDialogue"
            >
              <DialogContent>
                {this.state.eventStatus === "Active" ? (
                  <span style={{ textAlign: "center" }}>
                    <p className="m-0" style={{ fontSize: "18px" }}>
                      {this.state.eventStatus === "Active"
                        ? "You are about to permanently delete the Event"
                        : "By deleting this event, all of the event data (including send history) will be deleted."}
                      <br></br>
                      <span
                        style={{
                          color: " #37517e",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        “{this.state.eventName}”.
                      </span>
                    </p>
                  </span>
                ) : (
                  <span style={{ textAlign: "start" }}>
                    <p className="m-0" style={{ fontSize: "18px" }}>
                      By deleting this event, all of the event data (including send
                      history) will be deleted.
                    </p>
                  </span>
                )}
              </DialogContent>
              <DialogActions
                style={{
                  // marginTop: "1em",
                  padding: "1em",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  type="button"
                  style={{
                    background: "#37517e",
                    color: "#fff",
                    marginRight: "1rem",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<SaveIcon />}
                  onClick={this.deleteEventToBackend.bind(this)}
                >
                  Confirm
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  type="button"
                  style={{
                    background: "#717373",
                    color: "#fff",
                    marginRight: "1rem",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<CloseIcon />}
                  onClick={this.handleDeleteEventClose.bind(this)}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </Tabs>
        </div >
      </>
    );
  }
}
export default withRouter(EventList);
